import { useState, type FormEvent } from "react";
import { Link, useSearchParams } from "react-router";
import { api } from "../api";
import { ErrorState } from "../ui/State";
export function BuildingAssistantAlpha() {
  const [q] = useSearchParams(),
    building = q.get("building") ?? "",
    [model, setModel] = useState<any>(),
    [draft, setDraft] = useState(""),
    [busy, setBusy] = useState(false),
    [error, setError] = useState<unknown>();
  async function ask(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const f = new FormData(e.currentTarget);
    setBusy(true);
    setModel(undefined);
    setDraft("");
    try {
      const result = await api<any>("/api/alpha/building-assistant", {
        method: "POST",
        body: JSON.stringify({
          building,
          question: f.get("question"),
          assisted: f.get("assisted") === "on",
        }),
      });
      setModel(result);
      setDraft(result.draft);
      setError(undefined);
    } catch (e) {
      setError(e);
    } finally {
      setBusy(false);
    }
  }
  return (
    <>
      <h1>Building evidence assistant</h1>
      <p>
        Find matching Work, assets and verified document versions that you may
        read in this building. Questions work best with a subject such as “lift
        servicing” or “fire assessment”. Results are bounded evidence, not a
        complete building assurance check.
      </p>
      {!building ? (
        <Link to="/alpha">Choose a building</Link>
      ) : (
        <>
          <form onSubmit={ask}>
            <label>
              Question
              <textarea
                name="question"
                required
                minLength={3}
                maxLength={500}
              />
            </label>
            <label>
              <input type="checkbox" name="assisted" /> Prepare an assisted
              explanation using the configured provider
            </label>
            <button disabled={busy}>
              {busy ? "Reviewing evidence…" : "Find evidence"}
            </button>
          </form>
          {Boolean(error) && <ErrorState error={error} />}{" "}
          {model && (
            <>
              <h2>{model.mode}</h2>
              <p>
                Read at {model.asOf}. Source records can change; reopen them
                before making a decision.
              </p>
              {model.answer.statements.map((s: any, i: number) => (
                <section className="panel" key={i}>
                  <p>{s.text}</p>
                  <ul>
                    {s.sourceIds.map((id: string) => {
                      const source = model.sources.find(
                        (x: any) => x.id === id,
                      );
                      return source ? (
                        <li key={id}>
                          <Link to={source.href}>
                            {source.kind}: {source.title}
                          </Link>
                          {source.version && (
                            <span> · Version {source.version}</span>
                          )}
                        </li>
                      ) : null;
                    })}
                  </ul>
                </section>
              ))}
              {!model.sources.length && (
                <p>
                  No matching readable evidence. Try another subject or inspect
                  the source registers.
                </p>
              )}
              <p>{model.answer.uncertainty}</p>
              <details>
                <summary>Evidence supplied to the answer</summary>
                {model.sources.map((s: any) => (
                  <section key={s.id}>
                    <h3>
                      <Link to={s.href}>
                        {s.kind}: {s.title}
                      </Link>
                    </h3>
                    <p>{s.facts}</p>
                    <p>Version {s.version ?? "Not versioned"}</p>
                  </section>
                ))}
              </details>
              <label>
                Draft for staff review
                <textarea
                  rows={12}
                  value={draft}
                  onChange={(e) => setDraft(e.target.value)}
                />
              </label>
              <p>
                Review citations and edit this draft before using it. Nothing is
                sent or acted upon.
              </p>
            </>
          )}
        </>
      )}
    </>
  );
}
